import axios from "axios";

const getToken = () => {
  return localStorage.getItem("ntk");
};

const headers = () => {
  const token = getToken();

  return {
    headers: {
      Authorization: token,
    },
  };
};

const compactParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

const exportCsvFile = async (path, params = {}) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}${path}`,
      compactParams(params),
      { ...headers(), responseType: "blob" },
    );
  } catch (error) {
    throw error.response || error;
  }
};

export const exportStoresCsv = (params) =>
  exportCsvFile("/admin/stores/export", params);
export const exportUsersCsv = (params) =>
  exportCsvFile("/admin/users/export", params);
export const exportOrdersCsv = (params) =>
  exportCsvFile("/admin/orders/export", params);
export const exportDriversCsv = (params) =>
  exportCsvFile("/admin/drivers/export", params);
export const exportProductsCsv = (params) =>
  exportCsvFile("/admin/products/export", params);
export const exportStorePayoutsCsv = (params) =>
  exportCsvFile("/admin/finance/store-payouts/export", params);
export const exportDriverPayoutsCsv = (params) =>
  exportCsvFile("/admin/finance/driver-payouts/export", params);
export const exportTransactionsCsv = (params) =>
  exportCsvFile("/admin/finance/transactions/export", params);
export const exportTaxDocumentsCsv = (params) =>
  exportCsvFile("/admin/finance/tax/export", params);
export const exportTicketsCsv = (params) =>
  exportCsvFile("/admin/support/tickets/export", params);
export const exportChatsCsv = (params) =>
  exportCsvFile("/admin/support/chats/export", params);
export const exportDisputesCsv = (params) =>
  exportCsvFile("/admin/support/disputes/export", params);
export const exportSafetyIncidentsCsv = (params) =>
  exportCsvFile("/admin/support/safety-incidents/export", params);
console.log(headers());

const profile = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/get-admin`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const editprofile = async (data, image) => {
  try {
    const params = new FormData();
    params.append("email", data.email);
    params.append("fullName", data.fullName);
    params.append("mobilenumber", data.mobilenumber);
    {
      image && params.append("image", image);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-admin`,
      params,
      headers(),
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};
const changepassword = async (values) => {
  try {
    const params = {
      oldPassword: values.oldpassword,
      newPassword: values.password,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/change-pass`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const subadminlist = async (page, searchvalue) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
    };
    console.log("1qs", params);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-subadmin`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addadminlist = async (value) => {
  try {
    const params = {
      email: value.email,
      fullName: value.name,
      mobilenumber: value.phonenumber,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-subadmin`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const deleteadminlist = async (value) => {
  try {
    const params = {
      id: value,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-subadmin`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
// Get customer profile
export const getCustomerProfile = (customerId) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/customer-profile`,
    { customerId },
    headers(),
  );
};

// Suspend customer
export const suspendCustomer = (customerId, durationDays, reason) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/customer/suspend`,
    { customerId, durationDays, reason },
    headers(),
  );
};

// Ban customer
export const banCustomer = (customerId, action) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/customer/ban`,
    {
      customerId,
      action,
    },
    headers(),
  );
};

// Credit customer account
export const creditCustomerAccount = (customerId, amount, reason) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/customer/credit`,
    {
      customerId,
      amount,
      reason,
    },
    headers(),
  );
};

// Send message to customer
export const sendMessageToCustomer = (customerId, message) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/customer/send-message`,
    {
      customerId,
      message,
    },
    headers(),
  );
};

// (Optional) Refund order – you may need to add a refund endpoint
export const refundOrder = (orderId) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/refund-order`,
    {
      orderId,
    },
    headers(),
  );
};

const supportlist = async (page, searchvalue) => {
  try {
    const params = {
      // page: page,
      // search: searchvalue,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support-get`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const supportdetails = async (id) => {
  try {
    const params = {
      id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support-details`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const replysupport = async (id, text) => {
  try {
    const params = {
      id: id,
      replybyAdmin: text,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support-reply`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const faqslist = async (searchvalue, listOptions = {}) => {
  try {
    const params = {
      search: searchvalue,
      ...listOptions,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-faq`,
      compactParams(params),
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addfaqs = async (text, answer) => {
  try {
    const params = {
      question: text,
      answer: answer,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-faq`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editfaqs = async (id, text, answer) => {
  try {
    const params = {
      id: id,
      question: text,
      answer: answer,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-faq`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const deletefaqs = async (id) => {
  try {
    const params = {
      id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-faq`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const vendorlist = async (
  page,
  searchvalue,
  categoryFilter,
  locationFilter,
  statusFilter,
  listOptions = {},
) => {
  console.log(page, searchvalue);
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      category: categoryFilter,
      location: locationFilter,
      status: statusFilter,
      ...listOptions,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-vendor`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const vendorrequestlist = async () => {
  try {
    const params = {};

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/vendor-request`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const approvvendor = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/stores/approve-reject`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const getallvendors = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/all-vendor`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const vendordetails = async (value, pagination = {}) => {
  try {
    const params = {
      storeId: value,
      catalogPage: pagination.catalogPage || 1,
      catalogPageSize: pagination.catalogPageSize || 10,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/stores/profile`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const executeStoreAction = (storeId, action, value) => {
  const payload = { storeId, action };
  if (action === "rate_change" && value !== null) {
    payload.commissionRate = value;
  }
  if (action === "edit_fulfillment" && value !== null) {
    payload.fulfillmentOption = value;
  }
  if (action === "edit_minimum_order" && value !== null) {
    payload.minOrderEnabled = value.enabled;
    payload.minOrderAmount = value.amount;
  }
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/stores/action`,
    payload,
    headers(),
  );
};
const nfcount = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/notification-count`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const nfdata = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/Admin-notification`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const voucherlist = async (params = {}) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-voucher`,
      compactParams(params),
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addvoucher = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-voucher`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editvoucher = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-voucher`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const deletevoucher = async (id) => {
  try {
    const params = {
      id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-voucher`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const categorylist = async (page, searchvalue, listOptions = {}) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      ...listOptions,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/get-category`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addcategorylist = async (img, text) => {
  try {
    const params = new FormData();
    params.append("image", img);
    params.append("name", text);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/add-category`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editcategorylist = async (id, text, img) => {
  try {
    const params = new FormData();
    params.append("id", id);
    params.append("image", img);
    params.append("name", text);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/update-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const subcategorylist = async (page, searchvalue, listOptions = {}) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      ...listOptions,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/get-subcategory`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addsubcategorylist = async (type, text) => {
  try {
    const params = {
      category_id: type,
      name: text,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/add-subcategory`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editsubcategorylist = async (id, value) => {
  try {
    const params = {
      id: String(id),
      name: value.name,
      category_id: String(value.type),
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/update-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const deletesubcategorylist = async (id) => {
  try {
    const params = { id: id };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/delete-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const deletecategorylist = async (id) => {
  try {
    const params = { id: id };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/category/delete-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const getdoc = async (value) => {
  try {
    const params = {
      //   id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/users/privacy-policy`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const updatedoc = async (value, data) => {
  try {
    const params = {
      id: value,
      text: data,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-update-privacy`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const deliverypersonlist = async (
  page,
  searchvalue,
  vehicleType,
  status,
  zone,
  listOptions = {},
) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      vehicleType: vehicleType === "all" ? "" : vehicleType,
      status: status === "all" ? "" : status,
      zone: zone === "all" ? "" : zone,
      ...listOptions,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-delivery`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
// Get driver profile
export const getDriverProfile = (id) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/drivers/profile`,
    { id },
    headers(),
  );
};
export const executeDriverAction = (
  driverId,
  action,
  suspendedUntil,
  message = "",
) => {
  const payload = { id: driverId, action };
  if (suspendedUntil) payload.suspendedUntil = suspendedUntil;
  if (message) payload.message = message;
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/drivers/action`,
    payload,
    headers(),
  );
};

const orderlist = async (filters = {}) => {
  try {
    const params = Object.fromEntries(
      Object.entries(filters).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined,
      ),
    );
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/all-orders`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const orderdetails = async (value) => {
  try {
    const params = {
      orderId: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/order-Details`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const cancelOrder = async (orderId) => {
  try {
    const response = await axios.post(
      "admin/orders/cancel",
      {
        orderId: orderId,
      },
      headers(),
    );

    return response;
  } catch (err) {
    throw err.response;
  }
};
const refundOrderbyadmin = async (orderId, reason) => {
  try {
    const response = await axios.post(
      "admin/orders/refund",
      {
        orderId: orderId,
        reason: reason,
      },
      headers(),
    );

    return response;
  } catch (err) {
    throw err.response;
  }
};
const reassignDriver = async (orderId, driverId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/orders/reassign-driver`,
      {
        orderId: orderId,
        driverId: driverId,
      },
      headers(),
    );

    return response;
  } catch (err) {
    throw err.response;
  }
};
const userlist = async (page, searchvalue, filter, listOptions = {}) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      filter: filter,
      ...listOptions,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-customer`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const deleteuser = async (id, type) => {
  try {
    const params = {
      type: type,
      id: id,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/user-delete`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const blockuser = async (id, type, action) => {
  try {
    const params = {
      type: type,
      id: id,
      action: action,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/user-blockunblock`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const deliverrequestlist = async () => {
  try {
    const params = {};

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/deliveryperson-request`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const productdelete = async (value) => {
  try {
    const params = {
      id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/vendor/delete-product`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const editproduct = async (value) => {
  try {
    const params = new FormData();
    params.append("id", value.id);
    params.append("about", value.info.about);
    params.append("name", value.info.name);
    params.append("category_id", value.cat.id);
    params.append("categoryName", value.cat.name);
    params.append("subcategory_id", value.info.subcategory);
    params.append("imageIdToRemove", value.removeimg);
    for (let i = 0; i < value.image.length; i++) {
      params.append("images", value.image[i]);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/vendor/update-product`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const approvdeliver = async (params) => {
  console.log(params);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/approve-deliveryperson`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const getallcategory = async (params = {}) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/category/all-category`,
      { ...headers(), params: compactParams(params) },
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const getallsubcategory = async (id) => {
  try {
    const params = {
      category_id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/all-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const bannerlist = async (page, searchvalue, listOptions = {}) => {
  try {
    const params = {
      page: page,
      pageSize: 10,
      search: searchvalue,
      ...listOptions,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/banner/get-banner`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};
const addbanner = async (title, image) => {
  try {
    const params = new FormData();
    params.append("title", title.name);
    {
      title.for && params.append("vendorId", title.for);
    }
    params.append("image", image);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/banner/add-banner`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editbanner = async (id, title, image) => {
  try {
    const params = new FormData();
    params.append("id", id);
    params.append("title", title.name);
    {
      title.for && params.append("vendorId", title.for);
    }
    {
      image && params.append("image", image);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/banner/update-banner`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const deletebanner = async (id) => {
  try {
    const params = {
      id: id,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/banner/delete-banner`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const dashboard = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/dashboard`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

// not used now
// ==================================================

const usercount = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/Current-Month-Users`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const sendreply = async (id, email, msg) => {
  try {
    const params = {
      id: id,
      user_email: email,
      reply_msg: msg,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}ReplyContactUs`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const SendPushNftTo = async (value, usertoken) => {
  try {
    const params = {
      title: value.title,
      message: value.message,
      device_token: usertoken,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}SendPushNftTo`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const SendPushNftToALl = async (value) => {
  try {
    const params = {
      title: value.title,
      message: value.msg,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}SendPushNftToALl`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const language = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}LanguageList`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const languagestatus = async (value, status) => {
  try {
    const params = {
      id: value,
      status: status ? "2" : "1",
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}ChangeLangStatus`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const addlanguage = async (name, img) => {
  try {
    const params = new FormData();
    params.append("image", img);
    params.append("name", name);
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}AddLanguage`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};
const editlanguage = async (name, img, id) => {
  try {
    const params = new FormData();
    {
      img && params.append("image", img);
    }
    params.append("name", name);
    params.append("id", id);

    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}UpdateLanguage`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response;
  }
};

const getterms = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/Terms-Condition`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const getprivacy = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/Privacy-Policy`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const getabout = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/About-Us`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const feedetail = async (params = {}) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-fee`,
      compactParams(params),
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const editfees = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-fees`,
      compactParams(params),
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
const smtpdetail = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-smtpsetting`,
      compactParams(params),
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

const editsmtp = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/smtp-setting`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const getSettings = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/settings`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const updateGeneralSettings = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/settings/general`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const updatePricingSettings = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/settings/pricing`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const updateDeliverySettings = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/settings/delivery`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

export const updateLegalSettings = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/settings/legal`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
/* ==========================================
            SALES REPORT
========================================== */

const getSalesReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/sales`,
      { ...headers(), params: compactParams(params) },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

/* ==========================================
            CUSTOMER REPORT
========================================== */

const getCustomerReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/customers`,
      { ...headers(), params: compactParams(params) },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

/* ==========================================
            DRIVER REPORT
========================================== */

const getDriverReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/drivers`,
      { ...headers(), params: compactParams(params) },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

/* ==========================================
            STORE REPORT
========================================== */

const getStoreReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/stores`,
      { ...headers(), params: compactParams(params) },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

/* ==========================================
            OPERATIONS REPORT
========================================== */

const getOperationReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/operations`,
      { ...headers(), params: compactParams(params) },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

/* ==========================================
            EXPORT REPORT
========================================== */

const exportReport = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/reports/export`,
      {
        params,
        responseType: "blob",
        ...headers(),
      },
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};
/* ==========================================
            SEARCH PRODUCTS
========================================== */

const searchProducts = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/products/search`,
      params,
      headers(),
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};
export const flagProduct = async (productId, flagReason) => {
  try {
    const params = {
      productId,
      flagReason,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/products/flag`,
      params,
      headers(),
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

export const removeProduct = async (productId, reason) => {
  try {
    const params = {
      productId,
      reason,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/products/remove`,
      params,
      headers(),
    );

    return response;
  } catch (error) {
    throw error.response;
  }
};

// /////////////////================= Finance =================///////////////////

// Revenue Overview
export const getRevenueOverview = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/revenue-overview`,
      params,

      {
        ...headers(),
      },
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// Store Payouts
export const getStorePayoutsList = async (params = {}) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/store-payouts/list`,
      compactParams(params),
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const getStorePayoutsHistory = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/store-payouts/history`,
      compactParams(params),
      {
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const manualPayout = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/store-payouts/manual`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// Driver Payouts
export const getDriverPayoutsList = async (params = {}) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/driver-payouts/list`,
      compactParams(params),
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const getDriverPayoutsHistory = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/driver-payouts/history`,
      compactParams(params),
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const updateDriverPayoutStatus = async (data) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/driver-payouts/update-status`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// Transactions
export const getTransactions = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/transactions`,
      compactParams(params),

      {
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Tax
export const get1099TaxFigures = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/tax/drivers-1099`,
      compactParams(params),

      {
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const getSalesTaxReport = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/tax/sales-tax-report`,
      compactParams(params),

      {
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const exportCSV = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/tax/export-csv`,
      compactParams(params),

      {
        ...headers(),
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// ===================== Promotions =====================

// Promotion List
export const getPromotionsList = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/list`,
      compactParams(params),
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Create Promotion
export const createPromotion = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/create`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Promotion Details & Analytics
export const getPromotionDetails = async (id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/details`,
      { id },
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response || error;
  }
};

// Promotion lifecycle: pause, resume, expire, disable
export const setPromotionStatus = async (id, action) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/status`,
      { id, action },
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response || error;
  }
};

// Update Promotion
export const updatePromotion = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/update`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Enable / Disable Promotion
export const togglePromotion = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/toggle`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Delete Promotion
export const deletePromotion = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/finance/promotions/delete`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// ===================== Banners =====================

// Banner List
export const getBannersList = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/banners/list`,
      params,
      {
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Create Banner
export const createBanner = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/banners/create`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Update Banner
export const updateBanner = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/banners/update`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// Toggle Banner
export const toggleBanner = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/banners/toggle`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// Delete Banner
export const deleteBanner = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/banners/delete`,
      data,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};

// ===================== Announcements =====================

// Announcement List
export const getAnnouncementsList = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/announcements/list`,
      params,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Create Announcement
export const createAnnouncement = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/announcements/create`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Cancel Announcement
export const cancelAnnouncement = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/announcements/cancel`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// ===================== Referral =====================

// Referral Settings
export const getReferralList = async (params = {}) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/referrals/list`,
      params,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};
export const getReferralSettings = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/referrals/settings`,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Update Referral Settings
export const updateReferralSettings = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/marketing/referrals/settings`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Tickets
export const getTicketsList = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/support/tickets/list`,
      {
        params,
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const assignTicket = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/tickets/assign`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const replyTicket = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/tickets/reply`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Live Chat
export const getActiveChats = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/support/chats/active`,
      {
        params,
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const getChatHistory = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/support/chats/history`,
      {
        params,
        ...headers(),
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const sendChatReply = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/chats/reply`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Disputes
export const getDisputesList = async (params = {}) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/support/disputes/list`,
      { ...headers(), params },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const createDispute = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/disputes/create`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const resolveDispute = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/disputes/resolve`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Safety Incidents
export const getSafetyIncidents = async (params = {}) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/support/safety-incidents/list`,
      { ...headers(), params },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export const updateSafetyIncident = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/support/safety-incidents/update`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};
// ===================== Admin Team =====================

// Admin List
export const getAdminsList = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/team/list`,
      {
        ...headers(),
        params,
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Add Admin
export const addAdmin = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/team/add`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Delete Admin

export const deleteAdmin = async (data) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/admin/team/delete`,
      {
        ...headers(),
        data: {
          adminId: String(data.adminId).trim(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Get Role Permissions Mapping
export const getRolePermissionsMapping = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/team/role-permissions/mapping`,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Update Role Permissions Mapping
export const updateRolePermissionsMapping = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/team/role-permissions/mapping`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Activity Log
export const getActivityLog = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/team/activity-log`,
      {
        ...headers(),
        params,
      },
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Toggle 2FA
export const toggle2FA = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/team/2fa/toggle`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

// Verify 2FA
export const verify2FA = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/team/2fa/verify`,
      data,
      headers(),
    );
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export default profile;
export {
  vendorlist,
  subadminlist,
  addadminlist,
  addcategorylist,
  categorylist,
  editcategorylist,
  editprofile,
  changepassword,
  dashboard,
  usercount,
  getterms,
  getprivacy,
  userlist,
  sendreply,
  SendPushNftTo,
  SendPushNftToALl,
  language,
  addlanguage,
  languagestatus,
  editlanguage,
  getdoc,
  updatedoc,
  getabout,
  subcategorylist,
  editsubcategorylist,
  deletesubcategorylist,
  addsubcategorylist,
  getallcategory,
  editproduct,
  getallsubcategory,
  vendorrequestlist,
  deliverrequestlist,
  approvdeliver,
  approvvendor,
  vendordetails,
  productdelete,
  deliverypersonlist,
  orderlist,
  orderdetails,
  bannerlist,
  addbanner,
  editbanner,
  deletebanner,
  nfcount,
  nfdata,
  supportlist,
  supportdetails,
  replysupport,
  faqslist,
  addfaqs,
  editfaqs,
  deletefaqs,
  getallvendors,
  feedetail,
  editfees,
  deleteuser,
  blockuser,
  deleteadminlist,
  voucherlist,
  addvoucher,
  deletevoucher,
  editvoucher,
  smtpdetail,
  editsmtp,
  deletecategorylist,
  cancelOrder,
  refundOrderbyadmin,
  reassignDriver,
  getSalesReport,
  getCustomerReport,
  getDriverReport,
  getStoreReport,
  getOperationReport,
  exportReport,
  searchProducts,
};
